<template>
    <div class="booking-form-wrapper">
        <div class="block">
            <h3>{{ $t("bookings.booking") | capitalize }} {{ booking.booking_number }}</h3>
            <div class="columns">
                <div class="column">
                    <div>
                        <h4>{{ $t("bookings.period") | capitalize }}</h4>
                        <p>
                            {{ booking.date_from | localizedDate('L') }}
                            {{ $t("bookings.until") }}
                            {{ booking.date_until| localizedDate('L') }}
                        </p>
                    </div>
                </div>

                <div class="column">
                    <div>
                        <h4>{{ $t("bookings.campsites") | capitalize }}</h4>
                        <p v-for="campsite in booking.campsites">
                            {{ campsite.name }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import filters from '../../../filters';

    export default {
        name: 'booking-form',

        props: ['booking'],

        filters: filters,
    };
</script>



// WEBPACK FOOTER //
// src/views/components/booking/bookingForm.vue